import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Divider } from '@mui/material';

import { useAppMonitor } from '../../../../monitor';
import { deleteUnusedReferenceLines } from '../../../../store/actions/deletionActions';
import { useAppDispatch } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function ReferenceLinesContainerMenu() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  return (
    <SceneMenuContent>
      <AddItemMenuItem type="referenceLine" />

      <Divider />

      <SceneMenuItem
        icon={<DeleteIcon />}
        text="Delete Unused Reference Lines"
        onClick={() => {
          dispatch(deleteUnusedReferenceLines());
          monitor.recordInteraction('Delete Unused Reference Lines menu item clicked');
        }}
      />
    </SceneMenuContent>
  );
}
